
import { Input } from "./_Input";
import { InputNumber } from "./_InputNumber";

export * from "./_Input";
export * from "./_InputNumber";

Input.Number = InputNumber